<template>
    <div class="form">
        <template v-if="hasAccounts">
            <h2>We've found these accounts</h2>
            <a @click.prevent="clear" href="#">Search again</a>
            <ul class="accounts">
                <li :key="account.id" v-for="account in accounts" class="accounts__item">
                    <a :href="account.url">
                        <span class="accounts__item__initials">{{ account.initials }}</span>
                        <span class="accounts__item__name">{{ account.display_name }}</span>
                    </a>
                </li>
            </ul>
        </template>
        <template v-else>
            <div class="form__group" :class="{'form__group--error': form.errors.has('email')}">
                <label for="email" class="form__label">Your email address</label>
                <input v-model="form.email" id="email" placeholder="you@example.com" label="Email address" type="email" class="form__input" autofocus>

                <p v-if="form.errors.has('email')" class="form__help form__help--error">
                    {{ form.errors.get('email') }}
                </p>
            </div>
            <button to="verification" @click="submit" :disabled="form.busy" type="submit" class="button button--primary button--block">Next</button>
            <a class="button button--link button--block" href="/get-started">Or create a new account</a>
        </template>
    </div>
</template>
<script>
import Form from '../../helpers/Form'

export default {
    data () {
        return {
            accounts: [],
            form: new Form({
                email: ''
            })
        }
    },

    methods: {
        submit () {
            this.form.post('/api/account/search').then((response) => {
                this.accounts = response.tenants
            })
        },

        clear () {
            this.form.email = ''
            this.accounts = []
        }
    },

    computed: {
        hasAccounts () {
            return this.accounts.length > 0
        }
    }
}
</script>
<style scoped lang="less">
    @import "../../../less/variables";
    @import "../../../less/mixins/size";

    .accounts {
        display: flex;
        flex-direction: column;
        padding-left: 0;
        list-style: none;
    }

    .accounts__item {
        background-color: @lightbluegray;
        border: 1px solid @gray;
        border-radius: 5px;
        padding: 10px;
        margin-top: 10px;

        a {
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }

        &:hover {
            background-color: @gray;
        }
    }

    .accounts__item__initials {
        align-items: center;
        background-color: @darkernavy;
        border-radius: @radius;
        color: #FFF;
        display: flex;
        justify-content: center;
        .size(35px);
        text-align: center;
        text-decoration: none;
    }

    .accounts__item__name {
        display: block;
        margin-left: 10px;
        color: @black;
    }

</style>
